import React from "react";
import CustomerCardStyles from "./CustomerCardStyles";
import { Box, Card, Typography } from "@mui/material";
import { capitalizeFirstLetter } from "../../utils/Utility";

const CustomerCard = ({ item }: any) => {
  return (
    <Box>
      <Card sx={CustomerCardStyles.customerCard}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: "20px",
            width: "100%",
            "@media (max-width:600px)": { flexDirection: "column" },
          }}
        >
          <Box>
            <Typography>{capitalizeFirstLetter(item?.customerName)}</Typography>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default CustomerCard;
